module.exports = __webpack_public_path__ + "static/img/1.1b39e26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimages/1.png
// module id = juLL
// module chunks = 1